import "./App.css";
import TopUp from "./pages/Topup";
import Navigation from "./Routes/Navigation";

function App() {
  return (
    <div className="App">
      <Navigation />
    </div>
  );
}

export default App;
